// extracted by mini-css-extract-plugin
module.exports = {"Figure":"Figure_Figure__LwCc2","Pending":"Figure_Pending__Bilmu","Resolved":"Figure_Resolved__Ht6Pa","Rejected":"Figure_Rejected__ZJxyC","Caption":"Figure_Caption__2UK1C"};